export enum PageDialogVariant {
  NEW,
  EDIT,
  READ_ONLY,
}
